import styled from '@emotion/styled';
import React from 'react';
import Responsive from '../../../../../ui/utils/Responsive';
import { BookingDetailsTable } from './BookingDetailsTable';
import { BookingPersonalDetailsTable } from './BookingPersonalDetailsTable';
import { FullAmendAction } from './actions/FullAmendAction';
import { PartialAmendAction } from './actions/PartialAmendAction';
import { CancelAction } from './actions/CancelAction';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { IBooking } from '../../../domain/booking/models/IBooking';

export interface IBookingDetailsProps {
	booking: IBooking;
}

export const BookingDetails = ({ booking }: IBookingDetailsProps) => {
	const { t } = useTranslation();
	const shouldShowActions = booking.status !== 'canceled';

	return (
		<>
			<StyledDetailsSection>
				<BookingDetailsTable booking={booking} />

				{shouldShowActions && <FullAmendAction booking={booking} />}
			</StyledDetailsSection>

			<StyledDetailsSection>
				<h3>{t('parking_booking_details_personal_details_section_header')}</h3>
				<BookingPersonalDetailsTable
					personalDetails={booking.personalDetails}
					paymentDetails={booking.paymentDetails}
					vehicleDetails={booking.vehicleDetails}
				/>
				{shouldShowActions && (
					<>
						<PartialAmendAction booking={booking} />
						<CancelAction booking={booking} />
					</>
				)}
			</StyledDetailsSection>
		</>
	);
};

const StyledDetailsSection = styled.div`
	margin-bottom: 40px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-bottom: 24px;
	}
`;
